/**
 * Footer social link with animated outline circle on hover.
 * Uses Framer Motion pathLength for a drawing effect (see motion.dev/tutorials/react-path-drawing).
 */

import React, { useState } from "react";
import { motion } from "framer-motion";
import Icon from "../Icon";
import * as styles from "./FooterSocialLink.module.scss";

const draw = {
  hidden: { pathLength: 0.001, opacity: 0 },
  visible: {
    pathLength: 1,
    opacity: 1,
    transition: {
      pathLength: { duration: 0.4, ease: "easeInOut" },
      opacity: { duration: 0.01 },
    },
  },
  exit: {
    pathLength: 0.001,
    opacity: 0,
    transition: {
      pathLength: { duration: 0.3, ease: "easeInOut" },
      opacity: { duration: 0.01 },
    },
  },
};

export default function FooterSocialLink({ href, platform, ariaLabel }) {
  const [isHovered, setIsHovered] = useState(false);
  const size = 44;
  const strokeWidth = 3;
  const r = (size - strokeWidth) / 2;
  const cx = size / 2;
  const cy = size / 2;

  return (
    <li>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={ariaLabel}
        className={styles.link}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <svg
          className={styles.circleSvg}
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          aria-hidden
        >
          <motion.circle
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke="var(--color-primary)"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            variants={draw}
            initial="hidden"
            animate={isHovered ? "visible" : "exit"}
          />
        </svg>
        <span className={styles.iconWrap}>
          <Icon name={platform?.toLowerCase()} size="2rem" />
        </span>
      </a>
    </li>
  );
}
